module.exports = __webpack_public_path__ + "037d950b1ab1d7af903029604aa3d9ea.pdf";